import React from "react"
import PaginationItem from "../bootstrap/pagination_item"
import Pagination from "../bootstrap/pagination"

const PaginationComponent = props => {
  // Number of entries
  const loopLength = props.years.length

  // Find out what index the current year is at
  let itemIndex = -1

  for (let number = 0; number < loopLength; number++) {
    if (props.years[number].node.base === props.year) {
      itemIndex = number
    }
  }

  // We want to center year unless it is the first or last year
  // So if items == 0 or itemIndex is == loopLenght-1
  // Figure out starting index
  let startingIndex = -1

  if (itemIndex > 0 && itemIndex < loopLength - 1) {
    startingIndex = itemIndex - 1 // has one before and after
  } else if (itemIndex === 0) {
    startingIndex = 0 // is at the first year
  } else {
    startingIndex = loopLength - 3 // is at the last year and needs to rewind by 3
  }

  // For previous item
  let previousItem = -1
  if (itemIndex > 2) {
    previousItem = itemIndex - 3
  } else previousItem = 0

  const previousInd =
    "/" + props.type + "/" + props.type + props.years[previousItem].node.base

  // For last item
  const lastInd =
    "/" + props.type + "/" + props.type + props.years[loopLength - 1].node.base

  // For next item
  let nextItem = -1

  if (itemIndex < loopLength - 4) {
    nextItem = itemIndex + 3
  } else nextItem = loopLength - 1

  const nextInd =
    "/" + props.type + "/" + props.type + props.years[nextItem].node.base

  // Build group of pagination items
  let items = []
  for (let number = startingIndex; number < startingIndex + 3; number++) {
    items.push(
            <PaginationItem
              key={number}
              active = {String(props.years[number].node.base) !==
              String(props.year) ? false : true}
              href={String(props.years[number].node.base) !==
                String(props.year) ? `/${props.type}/${props.type}${props.years[number].node.base}`: "" }
            >
              {props.years[number].node.base}
            </PaginationItem>
    )
  }

  //<span aria-hidden="true">‹</span>
  //<span aria-hidden="true">›</span>
  //<span aria-hidden="true">»</span>

  return (
    <Pagination type={props.type}>
      
      <PaginationItem
        disabled={itemIndex === 0 ? true : false}
        href= {itemIndex === 0 ? "" : `/${props.type}/${props.type}${props.years[0].node.base}`}
      >
        <span aria-hidden="true">«</span>
        <span className="visually-hidden">First</span>
      </PaginationItem>
      <PaginationItem disabled={itemIndex === 0 ? true : false} href={itemIndex === 0 ? "" : previousInd}>
        <span aria-hidden="true">‹</span>
        <span className="visually-hidden">Previous Group of 3</span>
      </PaginationItem>
      {items}
      <PaginationItem disabled={itemIndex === loopLength - 1 ? true : false} href={itemIndex === loopLength - 1 ? "": nextInd}>
        <span aria-hidden="true">›</span>
        <span className="visually-hidden">Next Group of 3</span>
      </PaginationItem>
      <PaginationItem disabled={itemIndex === loopLength - 1 ? true : false} href={itemIndex === loopLength - 1 ? "": lastInd}>
        <span aria-hidden="true">»</span>
        <span className="visually-hidden">Last</span>
      </PaginationItem>
    </Pagination>
  )
}

export default PaginationComponent
